import React from "react";
import "./MyGhostSelect.css";

function MyGhostSelect({
  icon = "📁",         // 버튼에 표시될 아이콘
  title = "",         // 툴팁 용도
  value,              // 현재 선택된 값
  onChange,           // 변경 핸들러
  options = [],       // [{value:"", label:""}, ...]
  placeholder = "",   // 선택 안 했을 때 보여줄 값 (드롭다운 내부)
}) {
  return (
    <div className="ghost-select-wrap" title={title}>
      {/* 실제로 눈에 보이는 아이콘 버튼 부분 */}
      <button type="button" className="ghost-select-button">
        {icon}
      </button>

      {/* 실제 선택 기능을 하는 투명 <select> */}
      <select className="ghost-select" value={value} onChange={onChange}>
        {/* 선택 안 한 상태 표시용 */}
        {placeholder && (
          <option value="">
            {placeholder}
          </option>
        )}
        {/* 옵션들 렌더링 */}
        {options.map((opt, idx) => (
          <option key={idx} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}

export default MyGhostSelect;
